import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-driveb-reason-dialog",
    templateUrl: "./reason-dialog.component.html",
    styleUrls: ["./reason-dialog.component.scss"],
    standalone: false
})
export class ReasonDialogComponent implements OnInit {
  reason = new UntypedFormControl("", [Validators.required]);

  constructor(
    private matDialogRef: MatDialogRef<ReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  closeDialog(isSubmitted: boolean): void {
    this.matDialogRef.close(isSubmitted ? this.reason.value : null);
  }
}
